module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-epigraph element-without-heading",
    attrs: {
      "id": "intro-to-rough-draft"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "intro-to-rough-draft-text"
    }
  }, [_c('div', {
    staticClass: "blockquote-container prose without-attribution"
  }, [_c('blockquote', {
    staticClass: "prose without-attribution"
  }, [_c('p', {
    staticClass: "first blockquote-content blockquote-content-prose"
  }, [_c('i', [_vm._v("When my professional writing career was just getting under way, I was eagerly pursuing book contracts, building my name, selling stories to the major magazines, clawing myself up one step at a time. A hot new author exploded on the scene with a universally celebrated first novel, which won a bunch of awards; everybody read it, everybody talked about it.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose"
  }, [_c('i', [_vm._v("And we never heard from him again. No second novel that I knew of, no short story publications. The guy had achieved the pinnacle of success that so many of us longed for … and then he just disappeared. Why would anyone do that? The question obsessed me, and I still don’t know the answer.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose"
  }, [_c('i', [_vm._v("“Rough Draft” explores that question, and I think it’s one of my most powerful stories.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f94bece","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introtoroughdraft.vue
// module id = 84
// module chunks = 0